import React from 'react';
import {Route, Redirect} from "react-router-dom";
import {withCookies} from "react-cookie";

class PrivateRoute extends React.Component {
    isLogin(){
        let id = this.props.cookies.get('id');
        let role = this.props.cookies.get('role');
        let token = this.props.cookies.get('token');
        if(id === undefined || id === null || role === undefined || role === null || token === undefined || token === null){
            return false;
        }
        return true;
    }

    render(){
        let Component = this.props.component;
        let from = this.props.location;
        return (
            <Route render={(props) => (
                (this.isLogin()) ? (
                    <Component {...props} {...this.props}/>
                ) : (
                    <Redirect to={{
                        pathname: "/login",
                        state: from
                    }}/>
                )
            )}/>
        );
    }
}

export default withCookies(PrivateRoute);
